import { jsx } from "panel";
export function template() {
  const timerText = this.helpers.getLastRefreshRelativeFormat();
  const fullText = `${this.attr(`preface-text`)} ${timerText}`;
  const isCompact = this.attr(`is-compact`);
  return /* @__PURE__ */ jsx("div", {
    sel: ".last-updated-container",
    attrs: {
      elref: `timeDisplayContainer`
    },
    class: { "is-compact": isCompact }
  }, isCompact ? timerText : fullText);
}
